import { pointLetter } from "helpers/system";
import React, { Component } from "react";
import TimelinePoint from "./timelinePoint";

export default class Timeline extends Component {
    renderPoint = (point, index) => {
        const props = {
            point,
            key: index,
            letter: pointLetter(index),
            mergeMapViewport: this.props.mergeMapViewport,
            loadUnloadType: this.props.loadUnloadType,
            extendedPropertiesConfig: this.props.extendedPropertiesConfig,
        };
        return <TimelinePoint {...props} />;
    };

    render() {
        const { points } = this.props;
        return (
            <div className="show-bid__section pt-2">
                <div className="b-timeline">{points.map(this.renderPoint)}</div>
            </div>
        );
    }
}
